/** Platform route for an audited resource, or null when it has no page. */
export function resourceHref(resourceType: string, resourceId: string): string | null {
  const id = encodeURIComponent(resourceId);
  if (resourceType === "organization") return `/organizations/${id}`;
  if (resourceType === "facility") return `/facilities/${id}`;
  if (resourceType === "user" || resourceType === "user_profile") return `/users/${id}`;
  if (resourceType === "report") return `/moderation/reports/${id}`;
  if (resourceType === "appeal") return `/moderation/appeals/${id}`;
  return null;
}
